import { render, staticRenderFns } from "./UiActionRow.vue?vue&type=template&id=1d4c9f32&scoped=true"
import script from "./UiActionRow.vue?vue&type=script&lang=js"
export * from "./UiActionRow.vue?vue&type=script&lang=js"
import style0 from "./UiActionRow.vue?vue&type=style&index=0&id=1d4c9f32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d4c9f32",
  null
  
)

export default component.exports